import { poweredPlateIds } from './power';
import { isRainbowActive } from './rainbow';
import { isSurgeActive } from './surge';
/**
 * Module 63 (WP-63.E4) — the ONE place a board state becomes `ExitOptions`.
 *
 * Every programmatic mover (the plugin's `move()`, hints, tests) used to build
 * these by hand from `rainbowExitOptions` alone, which after Increment B meant
 * the programmatic path did not know about plates while the renderer did —
 * two callers composing the same primitives with different arguments, AUD-010's
 * shape. Now the options are derived here, from the state, and the three
 * clauses arrive together: colour (Rainbow), power (Surge), and the power set
 * itself from where the blocks stand.
 */
export function boardExitOptions(state) {
    return {
        ...(isRainbowActive(state) ? { rainbow: true } : {}),
        ...(isSurgeActive(state) ? { surge: true } : {}),
        poweredPlateIds: poweredPlateIds(state.blocks, state.puzzle.plates),
    };
}
